import { render, staticRenderFns } from "./MakePart.vue?vue&type=template&id=69cd664d&scoped=true&lang=pug&"
import script from "./MakePart.vue?vue&type=script&lang=js&"
export * from "./MakePart.vue?vue&type=script&lang=js&"
import style0 from "./MakePart.vue?vue&type=style&index=0&id=69cd664d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cd664d",
  null
  
)

export default component.exports